import React, { Component } from "react";
import DEFINE, { DETAIL_ACTIONS, UPLOAD_DIRECTORY } from "../../../../../../constants/Define";
import { checkUndefine } from "../../../../../../helpers/functions";
import {
  FormWrapperInputComponent,
  FormWrapperItem,
} from "../../../../common/component/Index";
import UploadImage from "../../../../common/component/UploadImage";
import UploadVideo from "../../../../common/component/UploadVideo";
import Wrapper from "../../../../common/component/Wrapper";
import Input from "./../../../../common/component/Input/index";
import RichTextEditor, {
  ClassicEditor,
} from "./../../../../common/component/RichTextEditor";
import { message, Divider, Tabs } from "antd";
import i18n from "./../../../../../../constants/initLng";
import { isEqual } from "lodash";

const { TabPane } = Tabs
export default class SupplierInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUploadingThumbImage: false,
      isUploadingSpecialImage: false,
      isUploadingSlideShowImages: false,
      isUploadingVideo: false,
      activeKey: '0'
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.uploadState && !isEqual(nextProps.uploadState, this.props.uploadState) && !nextProps.uploadState.isFetching && !nextProps.uploadState.isFetchingMultiple) {
      this.setState({isUploadingThumbImage: false});
      this.setState({isUploadingSpecialImage: false});
      this.setState({isUploadingSlideShowImages: false});
      this.setState({isUploadingVideo: false});
    }
  }

  render() {
    const { t, supplier, validation, action, validateTabContent } = this.props;
    return (
      <Wrapper className="supplier-info-section">
        <FormWrapperItem>
          <Wrapper className="col-md-12 row m-0 p-0 pl-3 pr-3">
            <Wrapper className="col-md-6 m-0 p-0 pr-0 pr-md-2">
              <FormWrapperInputComponent
                isRequired={true}
                isValidation={true}
                dataValidation={supplier.title}
                validation={validation.title}
                labelTitle={t(`item.supplier.infoDetail.title`)}
              >
                <Input
                  placeholder=""
                  type={`text`}
                  className={`form-control`}
                  name={`title`}
                  onChange={(e) => this.props.onChange("title", e.target.value)}
                  value={checkUndefine(supplier.title)}
                />
              </FormWrapperInputComponent>
            </Wrapper>

            <Wrapper className="col-md-6 m-0 p-0 pl-0 pl-md-2">
              <FormWrapperInputComponent
                labelTitle={t(`item.supplier.infoDetail.advisor`)}
                visible={action !== DETAIL_ACTIONS.TRANSLATE}
              >
                <Input
                  placeholder=""
                  type={`text`}
                  className={`form-control`}
                  name={`tripAdvisorCode`}
                  onChange={(e) =>
                    this.props.onChange("tripAdvisorCode", e.target.value)
                  }
                  value={checkUndefine(supplier.tripAdvisorCode)}
                />
              </FormWrapperInputComponent>
            </Wrapper>

            <Wrapper className="col-md-6 m-0 p-0 pl-0 pr-md-2">
              <FormWrapperInputComponent
                isRequired={true}
                isValidation={true}
                dataValidation={supplier.shortDescription}
                validation={validation.shortDescription}
                labelTitle={t(`item.supplier.infoDetail.shortDescription`)}
              >
                <Input
                  placeholder=""
                  type={`text`}
                  className={`form-control`}
                  name={`shortDescription`}
                  onChange={(e) =>
                    this.props.onChange("shortDescription", e.target.value)
                  }
                  value={checkUndefine(supplier.shortDescription)}
                />
              </FormWrapperInputComponent>
            </Wrapper>

            <Wrapper className="col-md-6 m-0 p-0 pl-0 pl-md-2">
              <FormWrapperInputComponent
                labelTitle={t(`item.supplier.infoDetail.mainStatus`)}
              >
                <Input
                  placeholder=""
                  type={`text`}
                  className={`form-control`}
                  name={`mainStatus`}
                  onChange={(e) =>
                    this.props.onChange("mainStatus", e.target.value)
                  }
                  value={checkUndefine(supplier.mainStatus)}
                />
              </FormWrapperInputComponent>
            </Wrapper>

            <Divider />
            <Wrapper className="col-md-12">
                <Tabs
                    onChange={this.handleChangeInfoTab}
                    activeKey={this.state.activeKey}
                    className="tab-extra-infos"
                    type="editable-card"
                    onEdit={this.handleEditInfoTab}
                >
                {supplier.extraInfos && supplier.extraInfos.map((info, index) => (
                    <TabPane 
                        tab={
                            <span 
                                className={
                                    `tab-content ${validateTabContent[index] && (validateTabContent[index].title || validateTabContent[index].content) ? 'is-errors' : ''}`
                                }
                            >
                                {info.title}
                            </span>
                        } 
                        key={index}
                    >
                        <Wrapper className="col-md-6">
                            <FormWrapperInputComponent
                                isRequired={'right'}
                                isValidation={true}
                                dataValidation={info.title}
                                validation={validateTabContent[index]?.title}
                                labelTitle={t(`item.supplier.titleContent`)}
                            >
                                <Input placeholder="" type={`text`}
                                    className={`form-control`}
                                    name={`title`} onChange={(e) => this.onChangeContent('title', e.target.value, index)}
                                    value={checkUndefine(info.title)} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-12">
                            <FormWrapperInputComponent
                                isRequired={'right'}
                                isValidation={true}
                                dataValidation={info.content}
                                validation={validateTabContent[index]?.content}
                                labelTitle={t(`item.supplier.content`)}
                            >
                                <RichTextEditor
                                    editor={ClassicEditor}
                                    data={info.content || ""}
                                    config={{ uploadDirectory: UPLOAD_DIRECTORY.IMAGES }}
                                    onChange={(event, editor) => {
                                        const value = editor.getData();
                                        return this.onChangeContent('content', value, index);
                                    }}
                                />
                            </FormWrapperInputComponent>
                        </Wrapper>
                    </TabPane>
                ))}
                </Tabs>
            </Wrapper>
            <Divider />

            <Wrapper className="col-md-6 m-0 p-0 pt-2">
              <FormWrapperInputComponent
                isRequired={true}
                isValidation={true}
                dataValidation={supplier.thumbImage}
                validation={validation.thumbImage}
                labelTitle={t(`item.supplier.infoDetail.thumbImage`)}
                visible={action !== DETAIL_ACTIONS.TRANSLATE}
              >
                <UploadImage
                  multiple={false}
                  thumbnailSize={120}
                  buttonSize={120}
                  thumbnailStyle={{ maxHeight: 250 }}
                  uploadText={t("item.supplier.uploadFile")}
                  loadingText={t("item.supplier.uploading")}
                  loading={this.state.isUploadingThumbImage}
                  onChange={(file) => this.onUploadImage(file.target.files[0], "thumbImage")}
                  onRemoveThumbnail={() => this.handleRemoveFile("thumbImage")}
                  thumbnails={
                    supplier.thumbImage
                      ? this.getThumbSources([supplier.thumbImage])
                      : undefined
                  }
                />
              </FormWrapperInputComponent>
            </Wrapper>

            <Wrapper className="col-md-6 m-0 p-0 pt-2">
              <FormWrapperInputComponent
                labelTitle={t(`item.supplier.infoDetail.specialImage`)}
                visible={action !== DETAIL_ACTIONS.TRANSLATE}
              >
                <UploadImage
                  multiple={false}
                  thumbnailSize={120}
                  buttonSize={120}
                  thumbnailStyle={{ maxHeight: 250 }}
                  uploadText={t("item.supplier.uploadFile")}
                  loadingText={t("item.supplier.uploading")}
                  loading={this.state.isUploadingSpecialImage}
                  onChange={(file) => this.onUploadImage(file.target.files[0], "specialImage")}
                  onRemoveThumbnail={() => this.handleRemoveFile("specialImage")}
                  thumbnails={
                    supplier.specialImage
                      ? this.getThumbSources([supplier.specialImage])
                      : undefined
                  }
                />
              </FormWrapperInputComponent>
            </Wrapper>

            <Wrapper className="col-md-6 m-0 p-0 pt-2">
              <FormWrapperInputComponent
                isRequired={true}
                isValidation={true}
                dataValidation={supplier.slideShowImages}
                validation={validation.slideShowImages}
                labelTitle={t(`item.supplier.infoDetail.slideShowImages`)}
                visible={action !== DETAIL_ACTIONS.TRANSLATE}
              >
                <UploadImage
                  multiple={true}
                  thumbnailSize={120}
                  buttonSize={120}
                  disabledUpload={supplier.slideShowImages?.length > 4}
                  thumbnailStyle={{ maxHeight: 250 }}
                  uploadText={t("item.supplier.uploadFile")}
                  loadingText={t("item.supplier.uploading")}
                  loading={this.state.isUploadingSlideShowImages}
                  onChange={(files) =>
                    this.onUploadImages(files, "slideShowImages")
                  }
                  onRemoveThumbnail={(src, index) => this.handleRemoveFile("slideShowImages", index)}
                  thumbnails={
                    supplier.slideShowImages
                      ? this.getThumbSources(supplier.slideShowImages)
                      : undefined
                  }
                />
              </FormWrapperInputComponent>
            </Wrapper>

            <Wrapper className="col-md-6 m-0 p-0 pt-2">
              <FormWrapperInputComponent
                labelTitle={t(`item.supplier.infoDetail.video`)}
                visible={action !== DETAIL_ACTIONS.TRANSLATE}
              >
                <UploadVideo
                  multiple={false}
                  videoSize={240}
                  buttonSize={120}
                  videoStyle={{ maxHeight: 240 }}
                  uploadText={t("item.supplier.uploadVideo")}
                  loadingText={t("item.supplier.uploading")}
                  loading={this.state.isUploadingVideo}
                  onChange={(files) =>
                    this.onUploadVideo(files, "video")
                  }
                  onRemoveVideo={(src, index) => this.handleRemoveFile("video")}
                  videoUrls={
                    supplier.video
                    ? this.getThumbSources([supplier.video])
                    : undefined}
                />
              </FormWrapperInputComponent>
            </Wrapper>
          </Wrapper>
        </FormWrapperItem>
      </Wrapper>
    );
  }

  getThumbSources(thumbs) {
    return (thumbs || []).map((t) => `${DEFINE.GENERAL.CDN_IMG_DEFAULT}${t}`);
  }

  onUploadImage = (file, fieldName, isMulti = 1) => {
    let imageValidation = ["image/jpeg", "image/jpg", "image/png"];
    if (imageValidation.includes(file.type)) {
      
      let onUploaded = () => {};
      switch (fieldName) {
        case "thumbImage":
          this.setState({isUploadingThumbImage: true})
          onUploaded = () => this.setState({isUploadingThumbImage: false})
          break;
        case "specialImage":
          this.setState({isUploadingSpecialImage: true})
          onUploaded = () => this.setState({isUploadingSpecialImage: false})
          break;
          case "slideShowImages":
            this.setState({isUploadingSlideShowImages: true})
            onUploaded = () => this.setState({isUploadingSlideShowImages: false})
            break;
        default:
          break;
      }
      this.props.onUploadFile({
        file: file,
        directory: UPLOAD_DIRECTORY.IMAGES,
        isFile: isMulti,
        field: fieldName,
        onUploaded
      });
    } else {
      message.error(i18n.t("validation.image"));
    }
  };

  onUploadImages = (file, fieldName) => {
    Object.keys(file.target.files).map((i) => {
      this.onUploadImage(file.target.files[i], fieldName, 2);
    });
  };

  onUploadVideo = (file, fieldName) => {
    let fileData = file.target.files;
    let imageValidation = ["video/mp4", "video/mov", "video/wmv", "video/flv", "video/3g2", "video/3gp"];
    Object.keys(fileData).map((i) => {
      if (imageValidation.includes(fileData[i].type)) {
        this.setState({isUploadingVideo: true});
        this.props.onUploadFile({
          file: fileData[i],
          directory: UPLOAD_DIRECTORY.IMAGES,
          isFile: 1,
          field: fieldName,
          onUploaded: () => this.setState({isUploadingVideo: false})
        });
      } else {
        message.error(i18n.t("validation.video"));
      }
    });
  };

  handleRemoveFile = (fieldName, index = -1) => {
    const { supplier } = this.props;
    if(index < 0){
        this.props.onChange(fieldName, undefined);
    }else{
        let newData = [...supplier[fieldName]];
        if(newData.length === 1){
          newData = undefined;
        }else{
          newData.splice(index, 1);
        }
        this.props.onChange(fieldName, newData);
    }
  };

  handleChangeInfoTab = activeKey => {
    this.setState({ activeKey });
  };

  handleEditInfoTab = (targetKey, action) => {
    switch (action) {
      case "add":
        this.handleAddInfoTab();
        break;
      case "remove":
        this.handleRemoveInfoTab(targetKey);
        break;
      default:
        break;
    }
  };

  handleAddInfoTab = () => {
    const { extraInfos } = this.props.supplier;
    extraInfos.push({ 
        title: 'Nội dung mới', 
        content: ''
    });
    this.props.onChange('extraInfos', extraInfos);
    this.setState({ 
      activeKey: (extraInfos.length - 1).toString()
    });
  };

  handleRemoveInfoTab = targetKey => {
    const extraInfos = [...this.props.supplier.extraInfos];
    const indexDelele = parseInt(targetKey);

    if(extraInfos.length <= 1) {
        return message.error('Phải giữ ít nhất một bài viết !');
    }

    if(!!extraInfos[indexDelele].content) {
        return message.error('Không thể xoá bài viết đang có nội dung!');
    }

    extraInfos.splice(indexDelele, 1);
    this.setState({ 
        activeKey: (indexDelele > 0 ? indexDelele - 1 : indexDelele).toString() 
    });
    this.props.onChange('extraInfos', extraInfos);
  };

  onChangeContent = (field, value, index) => {
    const extraInfos = [...this.props.supplier.extraInfos];
    extraInfos[index][field] = value.trimLeft();
    this.props.onChange('extraInfos', extraInfos);
  }
}
